import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-2138fde0")

_pushScopeId("data-v-2138fde0")
const _hoisted_1 = { class: "container is-max-widescreen mt-4 min-padding" }
const _hoisted_2 = {
  class: "breadcrumb is-left",
  "aria-label": "breadcrumbs"
}
const _hoisted_3 = { class: "icon is-small" }
const _hoisted_4 = /*#__PURE__*/_createVNode("span", null, "Home", -1)
const _hoisted_5 = { class: "is-active" }
const _hoisted_6 = { href: "#" }
const _hoisted_7 = { class: "columns" }
const _hoisted_8 = { class: "column is-one-third" }
const _hoisted_9 = { class: "column" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")
  const _component_router_link = _resolveComponent("router-link")
  const _component_Information = _resolveComponent("Information")
  const _component_Registration = _resolveComponent("Registration")
  const _component_Pickup = _resolveComponent("Pickup")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("nav", _hoisted_2, [
      _createVNode("ul", null, [
        _createVNode("li", null, [
          _createVNode(_component_router_link, { to: "/" }, {
            default: _withId(() => [
              _createVNode("span", _hoisted_3, [
                _createVNode(_component_font_awesome_icon, { icon: "home" })
              ]),
              _hoisted_4
            ]),
            _: 1
          })
        ]),
        _createVNode("li", _hoisted_5, [
          _createVNode("a", _hoisted_6, [
            _createVNode("span", null, "TN " + _toDisplayString(_ctx.info.trackingNumber), 1)
          ])
        ])
      ])
    ]),
    _createVNode("div", _hoisted_7, [
      _createVNode("div", _hoisted_8, [
        _createVNode(_component_Information, { info: _ctx.info }, null, 8, ["info"])
      ]),
      _createVNode("div", _hoisted_9, [
        (_ctx.info.container.cfs === 'KUEHDEHAM2')
          ? (_openBlock(), _createBlock(_component_Registration, {
              key: 0,
              trackingNumber: _ctx.info.trackingNumber,
              cfs: _ctx.info.container.cfs
            }, null, 8, ["trackingNumber", "cfs"]))
          : (_openBlock(), _createBlock(_component_Pickup, {
              key: 1,
              cfs: _ctx.info.container.cfs
            }, null, 8, ["cfs"]))
      ])
    ])
  ]))
})